var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "down", mode: "out-in" } }, [
    _vm.totalOrders
      ? _c(
          "div",
          { staticClass: "orders" },
          [
            _c("div", { staticClass: "header" }, [
              _vm._v(
                "\n      Limpezas futuras (" +
                  _vm._s(_vm.totalOrders) +
                  ")\n    "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "body" },
              _vm._l(_vm.confirmedOrders.slice(0, 2), function(order) {
                return _c("OrderCard", {
                  key: order.id,
                  attrs: { payable: order }
                })
              })
            ),
            _vm._v(" "),
            _vm.totalOrders > 2
              ? _c(
                  "button",
                  {
                    staticClass: "btn bg-purple",
                    on: {
                      click: function($event) {
                        _vm.open = true
                      }
                    }
                  },
                  [_vm._v("\n      Ver todos\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.open
              ? _c("ConfirmedPayablesList", {
                  attrs: { orders: _vm.confirmedOrders },
                  on: {
                    close: function($event) {
                      _vm.open = false
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6296a6a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6296a6a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/components/Payables/ConfirmedPayables.vue
// module id = null
// module chunks = 